import { render, staticRenderFns } from "./Exhibitors.vue?vue&type=template&id=4087b477&scoped=true&"
import script from "./Exhibitors.vue?vue&type=script&lang=js&"
export * from "./Exhibitors.vue?vue&type=script&lang=js&"
import style0 from "./Exhibitors.vue?vue&type=style&index=0&id=4087b477&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4087b477",
  null
  
)

export default component.exports